import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  consentGroup: {
    marginLeft: 35,
    marginTop: 10,
  },
  consent: {
    marginBottom: 10,
  },
  expandBtn: {
    display: 'block',
    marginLeft: 35,
    marginBottom: 10,
    fontSize: 12,
    textDecoration: 'underline',
    color: palette.primary.main,
    cursor: 'pointer',
  },
}));
